import { useEffect } from "react";

const useSingleKey = (key, callBack) => {

  const handleKeydown = (event) => {
    //Ameersha N - 22-11-2023 : BT-95888 Create Watchlist only single key should be taken  
    if (!event.ctrlKey && event.key.toLowerCase() === key) {
      callBack(event);
    } else { }
  };
  useEffect(() => {
    document.addEventListener("keydown", handleKeydown);
    return () => document.removeEventListener("keydown", handleKeydown);
  }, [callBack, handleKeydown]);
};

export default useSingleKey;